const api = {
  // 资料台账统计
  selectYhProjectFilesCompilation: '/business/yhProjectFiles/selectYhProjectFilesCompilation',
  // 分页查询资料台账列表
  selectYhProjectFilesByPage: '/business/yhProjectFiles/selectYhProjectFilesByPage'
}
export default api
